import { render, staticRenderFns } from "./ErrorLookLimit.vue?vue&type=template&id=5ef277da&"
import script from "./ErrorLookLimit.vue?vue&type=script&lang=js&"
export * from "./ErrorLookLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports